import { render, staticRenderFns } from "./ManagerBaseSettings.vue?vue&type=template&id=223a30f7"
import script from "./ManagerBaseSettings.vue?vue&type=script&lang=js"
export * from "./ManagerBaseSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports